﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import type { ApiStatus } from "~base/Services/API";
import type * as dataGatheringModel from "~base/Services/API/DataGathering/Model";
import { GatheringStatus } from "~base/Services/API/DataGathering/Model";

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type SetOperationInfo = {
    type: "setOperationInfo";
    data: dataGatheringModel.GetOperationResponse;
    status: ApiStatus;
};

export type TinkPageViewAction = SetOperationInfo;

export interface TinkPageState {
    operationInfo?: dataGatheringModel.GetOperationResponse;
    loading: boolean;
}

export function reducer<T>(
    state: TinkPageState,
    action: TinkPageViewAction
): TinkPageState {
    switch (action.type) {
        case "setOperationInfo": {
            let operationInfo;
            let isLoading;

            // Stop calling API if something went wrong
            if (action.status !== "Success") {
                isLoading = false;
                operationInfo = {
                    Status: GatheringStatus.Error,
                    Items: [
                        {
                            Status: GatheringStatus.Error,
                        } as dataGatheringModel.Item,
                    ],
                } as dataGatheringModel.GetOperationResponse;
            } else {
                // Otherwise, check item status and continue calling API if status is Pending
                const itemStatus = (action.data?.Items ?? [])[0]?.Status;
                isLoading = itemStatus === GatheringStatus.Pending;
                operationInfo = { ...action.data };
            }

            return {
                ...state,
                operationInfo: operationInfo,
                loading: isLoading,
            };
        }
    }
}

export const initialState = (): TinkPageState => {
    return { loading: true };
};
